let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lzuNx")).then(() => parcelRequire('6EsK2'));